import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nft-card-info-item-section mb-16" }
const _hoisted_2 = { class: "nft-card-info-item" }
const _hoisted_3 = { class: "nft-card-info-title mb-12" }
const _hoisted_4 = { class: "nft-card-info-content" }
const _hoisted_5 = { class: "info-col" }
const _hoisted_6 = { class: "nft-card-info-content" }
const _hoisted_7 = { class: "extra-row" }
const _hoisted_8 = { class: "col-text" }

import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import {parseQtnr} from '@/script/nft/nftQtnrScript';
import MvModal from '@/components/common/modal/MvModal.vue';
import {useModal} from '@/script/common/modalScript';
import NftQtnrModifyModal from '@/components/common/modal/nft/NftQtnrModifyModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NftCardQtnrInfoComp',
  props: {
  qtnrInfo: {
    default: {}
  },
  qtnrTemplate: {
    default: []
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n()

const qtnrList = computed(() => {
  return props.qtnrTemplate.map(qtnr => {
    const keyInfo = parseQtnr(qtnr ,t)
    return {
      label: keyInfo.name,
      value: props.qtnrInfo[qtnr.name],
    }
  })
})

const {
  isOpen,
  toggleModal,
} = useModal()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("nftCard.precaution.qtnr.title")), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qtnrList), (qtnr, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "info-row"
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(qtnr.label), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(qtnr.value), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('nftCard.precaution.qtnr.modifyAsk')), 1),
      _createElementVNode("div", {
        class: "val-text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(true)))
      }, _toDisplayString(_ctx.$t('nftCard.precaution.qtnr.modifyReq')), 1)
    ]),
    _createVNode(MvModal, {
      visible: _unref(isOpen),
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isOpen) ? (isOpen).value = $event : null))
    }, {
      content: _withCtx(() => [
        _createVNode(NftQtnrModifyModal, {
          onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleModal)(false)))
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})